import { createAsyncAction } from 'typesafe-actions';
import { APIErrorInterface } from '../../types';
import { DeleteVoicemailRequestPayload, GetVoicemailDetailsPayload, GetVoicemailFileAsBlobRequestPayload, SetMailboxMessagesFlagPayload, VoicemailDetails, VoicemailListRequestPayload } from './payloads';
import { AccountVoicemail } from '../../reducers/voicemails/reducer';

export const getVoicemailList = createAsyncAction(
    'GET_VOICEMAIL_LIST',
    'GET_VOICEMAIL_LIST_SUCCESSED',
    'GET_VOICEMAIL_LIST_FAILED',
)<
    VoicemailListRequestPayload,
    AccountVoicemail,
    APIErrorInterface
>();

export const getVoicemailFile = createAsyncAction(
    'GET_VOICEMAIL_FILE_AS_BLOB',
    'GET_VOICEMAIL_AS_BLOB_SUCCESS',
    'GET_VOICEMAIL_AS_BLOB_FAILED',
)<GetVoicemailFileAsBlobRequestPayload, undefined, undefined>();

export const deleteVoicemail = createAsyncAction(
    'DELETE_VOICEMAIL',
    'DELETE_VOICEMAIL_SUCCESS',
    'DELETE_VOICEMAIL_FAILED',
)<DeleteVoicemailRequestPayload, undefined, undefined>();

export const setMailboxMessagesFlag = createAsyncAction(
    'SET_MAILBOX_MESSAGES_FLAG',
    'SET_MAILBOX_MESSAGES_FLAG_SUCCESS',
    'SET_MAILBOX_MESSAGES_FLAG_FAILED',
)<SetMailboxMessagesFlagPayload, SetMailboxMessagesFlagPayload, undefined>();

export const getVoicemailDetails = createAsyncAction(
    'GET_VOICEMAIL_DETAILS',
    'GET_VOICEMAIL_DETAILS_SUCCESS',
    'GET_VOICEMAIL_DETAILS_FAILED',
)<GetVoicemailDetailsPayload, VoicemailDetails, undefined>();
